import React, { useEffect, useState } from "react";
import { deletePositions, getPositions } from "../../../data/db";
import { IOrderData, IRecords } from "../../../types";
import DeleteIcon from "./../../../images/delete.svg";
import { Dropdown, DropdownButton } from "react-bootstrap";

interface IPositionProps {
  data: {
    [key: string]: IRecords;
  }
  indexName: string;
  expiry: string;
  selectedExpiry: (exp: string) => void;
  expiries: string[];
  fetchData: (expiry: string) => void;
}

const PositionsTab = (props: IPositionProps) => {
  const [positions, setPositions] = useState<{ [key: string]: IOrderData }>({});
  const getLTP = (order: IOrderData) => {
    const data = props.data[order.symbol].data
      .flatMap((val: any) => [
        { ...val.CE, type: "Call" },
        { ...val.PE, type: "Put" },
      ])
      .filter(
        (val: any) =>
          val.strikePrice === order.strike &&
          val.type === order.option &&
          val.expiryDate &&
          props.expiry === order.expiry
      );
    if (data.length > 0) return data[0].lastPrice;
  };
  const getClassName = (price: number, ltp: number, qty: number, bookedPNL: number = 0) => {
    return getPNL(price, ltp, qty, bookedPNL) >= 0 ? "e-positive-color" : "e-negative-color";
  };
  const getPNL = (
    price: number,
    ltp: number,
    qty: number,
    bookedPNL: number = 0
  ) => {
    let res = 0;
    if (qty > 0) {
      res = (ltp - price) * qty;
    } else if (qty < 0) {
      res = (price - ltp) * Math.abs(qty);
    }
    return res + (bookedPNL || 0);
  };
  useEffect(() => {
    getPositions(props.indexName).then((res: any) =>
      setPositions(res)
    );
  }, [props.indexName]);

  const totalPNL = Object.keys(positions).reduce((acc, key) => {
    const { price, qty, bookedPNL, expiry } = positions[key];
    if(expiry !== props.expiry) {
      return acc;
    }
    return acc + getPNL(price, getLTP(positions[key]), qty, bookedPNL);
  }, 0);
  return (
    <>
      <div style={{ textAlign: "center" }}>
        <DropdownButton
          id="dropdown-basic-button"
          title={props.expiry}
          size="sm"
          variant="success"
        >
          {props.expiries.map((val, index) => {
            return (
              <Dropdown.Item
                key={index}
                onSelect={() => {
                  props.selectedExpiry(val);
                  props.fetchData(val);
                }}
              >
                {val}
              </Dropdown.Item>
            );
          })}
        </DropdownButton>
      </div>
      <div
        style={{
          width: "100%",
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <b>Total P/L</b>
        <b className={totalPNL >= 0 ? "e-positive-color" : "e-negative-color"}>
          {totalPNL.toFixed(2)}
        </b>
      </div>
      {Object.keys(positions).length === 0 && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Please add positions from watchlist tab
        </div>
      )}
      {Object.keys(positions).map((key) => {
        const { symbol, strike, option, price, qty, bookedPNL, expiry } =
          positions[key];
        const ltp = getLTP(positions[key]);
        if(expiry !== props.expiry)
          return null;
        return (
          <div key={key} className="e-positions-card">
            <div className="e-positions-left">
              <div>
                <b>
                  {symbol} {strike} {option}
                </b>
              </div>
              <div>
                Qty: {qty} @ {price.toFixed(2)}
              </div>
              <div style={{ color: "GrayText" }}>Expiry: {expiry}</div>
            </div>
            <div className="e-positions-right">
              <div className={getClassName(price, ltp, qty, bookedPNL)}>
                LTP: {ltp}
              </div>
              <div className={getClassName(price, ltp, qty, bookedPNL)}>
                P/L: {getPNL(price, ltp, qty, bookedPNL).toFixed(2)}
              </div>
              <div
                style={{
                  border: "1px solid gray",
                  borderRadius: "50%",
                  padding: "0px 4px",
                  display: "flex",
                  gap: "4px",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "28px",
                  width: "28px",
                }}
                onClick={() => {
                  deletePositions([positions[key]]);
                  getPositions(props.indexName).then((res) =>
                    setPositions(res)
                  );
                }}
              >
                <img src={DeleteIcon} alt="Delete" width="16px" height="16px" />
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default PositionsTab;
